// Ponto de encontro (2026-10-15): regras compartilhadas com o banco
// (supabase/migrations/20261015b_ponto_de_encontro.sql).

/** Padrão de presence_radius_m (platform_settings); as telas leem o valor
 *  vigente com usePickupRules. */
export const PRESENCE_RADIUS_M = 300

/** Padrão de pickup_change_lock_minutes (platform_settings). */
export const PICKUP_LOCK_MINUTES = 120

/** "2 horas", "90 minutos"... */
export function formatLock(minutes: number) {
  if (minutes % 60 === 0) {
    const h = minutes / 60
    return h === 1 ? '1 hora' : `${h} horas`
  }
  return `${minutes} minutos`
}

/** Mesma regra de _pickup_point_valid no banco: coordenadas dentro do Brasil. */
export function isValidPickupPoint(lat: number | null | undefined, lng: number | null | undefined) {
  return lat != null && lng != null && lat >= -34 && lat <= 6 && lng >= -74.5 && lng <= -28
}
